import Exception from "src/utils/exception";
import Constants from "src/utils/constants";
import DBOperationsComb from "src/utils/dbOperationsComb";

async function getFormFieldById(id) {
  try {
    const _fieldRes = await DBOperationsComb.getData(
      Constants.enums.TABLES_NAME_ENUM.FORM_FIELDS_TABLE,
      id,
      true
    );

    if (_fieldRes.error) {
      throw `Error fetching data of FIELD (ID: ${id}): ${_fieldRes.error}`;
    }
    return _fieldRes;
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

/**
 * form_fields rows (the field-type catalog). Offline-first — the catalog is
 * synced, and the form renderer needs it offline too.
 *
 * @returns {Promise<{data: Array|null, totalItems: number, error: string|null}>}
 */
async function getFormFieldsList(config = {}) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.FORM_FIELDS_TABLE,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return { error };
  }
}

export default {
  getFormFieldById,
  getFormFieldsList
};
